import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LegalizationService } from 'src/app/data/legalization.service';
import { LegalizationDetailsDto } from 'src/app/models/dtos/legalization-details-dto';
import { EmploymentType } from 'src/app/models/enums/employment-type-enum';
import { LegalizationAlertStatusEnum } from 'src/app/models/enums/legalization-alert-status-enum';
import { FileService } from 'src/app/shared/services/file-service';
import { LegalizationStatusHelperService } from '../../services/legalization-status-helper-service';

@Component({
  selector: 'app-legalization-details',
  templateUrl: './legalization-details.component.html',
  styleUrl: './legalization-details.component.scss',
  standalone: false
})
export class LegalizationDetailsComponent implements OnInit {
  @Input() id: number;
  @Input() documentId?: number;
  @Input() splitId: string;
  @Output() close = new EventEmitter<string>();

  loading = false;
  expandedPanels: { [key: string]: boolean } = {};

  legalizationDetails: LegalizationDetailsDto
  workerId: number;
  endpoint: string;
  public readonly legalizationAlertStatusEnum = LegalizationAlertStatusEnum;

  private readonly storageKey = 'legalizationDetailsExpandedPanels';
  readonly spinnerName = 'legalizationDetailsExpandedPanels';

  legalizationService = inject(LegalizationService);
  spinner = inject(NgxSpinnerService);
  fileService = inject(FileService);
  statusHelperService = inject(LegalizationStatusHelperService);

  ngOnInit(): void {
    const saved = localStorage.getItem(this.storageKey);
    if (saved) {
      this.expandedPanels = JSON.parse(saved);
    }

    this.spinner.show(this.spinnerName);
    this.legalizationService.getLegalizationDetails(this.id, this.documentId)
      .subscribe((data: LegalizationDetailsDto) => {
        this.legalizationDetails = data;
        this.workerId = data?.WorkerId;
        this.endpoint = `workers/${this.workerId}/files`;
        this.spinner.hide(this.spinnerName)
      });
  }

  isEmploymentAgreement(): boolean {
    return this.legalizationDetails?.AgreementDetails.EmploymentTypeId === EmploymentType.EmploymentAgreement
      || this.legalizationDetails?.AgreementDetails.EmploymentTypeId === EmploymentType.TemporaryEmploymentAgreement;
  }

  onClose(): void {
    this.close.emit(this.splitId);
  }

  download(fileId: number, fileName: string): void {
    this.fileService.downloadFile(fileId, fileName, this.endpoint);
  }

  onPanelOpened(panel: string) {
    this.expandedPanels[panel] = true;
    localStorage.setItem(this.storageKey, JSON.stringify(this.expandedPanels));
  }

  onPanelClosed(panel: string) {
    this.expandedPanels[panel] = false;
    localStorage.setItem(this.storageKey, JSON.stringify(this.expandedPanels));
  }

  public getAlertStatusClass(alertStatusId: number): string {
    return this.statusHelperService.getAlertStatusClass(alertStatusId);
  }

  public getStatusClass(legalizationStatusId: number): string {
    return this.statusHelperService.getStatusClass(legalizationStatusId);
  }
}
